<div class="container-fluid py-3">
  <a routerLink="/prod-data" class="btn btn-sm btn-outline-secondary mb-3">
    &larr; Back to Clients
  </a>
  <h5 class="mb-3">Production Data — {{ clientName || clientId }}</h5>

  <!-- Tabs -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'general'" (click)="activeTab = 'general'">General</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'variance'" (click)="activeTab = 'variance'">Variance History</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'billing'" (click)="activeTab = 'billing'">Report Recipients</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'wildcards'" (click)="activeTab = 'wildcards'">Wildcard Rules</button>
    </li>
  </ul>

  <!-- ── General ────────────────────────────────────────────────────────── -->
  <div *ngIf="activeTab === 'general'">
    <div *ngIf="linkLoading" class="text-muted">Loading...</div>
    <div *ngIf="!linkLoading && link" style="max-width: 560px;">
      <div class="mb-3">
        <label class="form-label">ORMS User ID</label>
        <input class="form-control" [(ngModel)]="link.accountId" placeholder="Account ID" />
      </div>
      <div class="mb-3">
        <label class="form-label">ORMS Market ID</label>
        <input class="form-control" type="number" [(ngModel)]="link.extClientId" placeholder="External Client ID" />
      </div>
      <div class="mb-3">
        <label class="form-label">Billing Frequency</label>
        <select class="form-select" [(ngModel)]="link.billingFrequency">
          <option [ngValue]="null">— Select —</option>
          <option *ngFor="let opt of billingOptions" [value]="opt">{{ opt }}</option>
        </select>
      </div>
      <div class="mb-3">
        <label class="form-label">Billing Rate ($ per well)</label>
        <div class="input-group" style="max-width:200px;">
          <span class="input-group-text">$</span>
          <input class="form-control" type="number" min="0" step="0.01"
                 [(ngModel)]="link.billingRate"
                 placeholder="0.75" />
        </div>
        <div class="form-text text-muted">If left blank, defaults to $0.75 per well.</div>
      </div>

      <hr />

      <div class="mb-3 form-check form-switch">
        <input class="form-check-input" type="checkbox" id="msaSigned"
               [(ngModel)]="link.msaSigned" />
        <label class="form-check-label" for="msaSigned">MSA Signed</label>
      </div>
      <div class="mb-3">
        <label class="form-label">MSA Signed Date</label>
        <input class="form-control" type="date" [(ngModel)]="link.msaSignedDate" />
      </div>
      <div class="mb-3">
        <label class="form-label">MSA Signed By</label>
        <select class="form-select" [(ngModel)]="link.msaSignedBy">
          <option [ngValue]="null">— None —</option>
          <option *ngFor="let u of users" [value]="u.id">{{ u.displayName }}</option>
        </select>
        <div *ngIf="link.msaSignedBy" class="form-text text-muted">
          {{ getUserName(link.msaSignedBy) }}
        </div>
      </div>

      <div class="d-flex gap-2 mt-3">
        <button class="btn btn-primary" (click)="saveLink()">Save</button>
        <button *ngIf="link.accountId" class="btn btn-outline-secondary"
                (click)="downloadAccountPermissions()" [disabled]="auditDownloading">
          {{ auditDownloading ? 'Downloading…' : 'EDI Owner Account Review' }}
        </button>
        <button *ngIf="link.accountId" class="btn btn-outline-success"
                (click)="runOpBilling()" [disabled]="opBillingRunning">
          {{ opBillingRunning ? 'Queuing…' : 'Run Billing' }}
        </button>
        <span *ngIf="opBillingQueued" class="text-success small align-self-center">Billing report queued. You'll receive an email when it's ready.</span>
      </div>
    </div>
  </div>

  <!-- ── Variance History ───────────────────────────────────────────────── -->
  <div *ngIf="activeTab === 'variance'">
    <button class="btn btn-sm btn-outline-success mb-2" (click)="showAddVariance = !showAddVariance">
      + Add Variance Record
    </button>

    <div *ngIf="showAddVariance" class="card p-3 mb-3" style="max-width:480px;">
      <div class="mb-2">
        <label class="form-label">Variance Date</label>
        <input class="form-control" type="date" [(ngModel)]="newVariance.varianceDate" />
      </div>
      <div class="mb-2">
        <label class="form-label">Well Count</label>
        <input class="form-control" type="number" [(ngModel)]="newVariance.wellCount" min="0" />
      </div>
      <div class="mb-2">
        <label class="form-label">Responsible User</label>
        <select class="form-select" [(ngModel)]="newVariance.responsibleUser">
          <option value="">— Select User —</option>
          <option *ngFor="let u of users" [value]="u.id">{{ u.displayName }}</option>
        </select>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-primary" (click)="addVariance()"
                [disabled]="!newVariance.responsibleUser || newVariance.wellCount < 0">Save</button>
        <button class="btn btn-sm btn-secondary" (click)="showAddVariance = false">Cancel</button>
      </div>
    </div>

    <div *ngIf="varianceLoading" class="text-muted">Loading...</div>
    <table *ngIf="!varianceLoading" class="table table-sm table-hover">
      <thead class="table-light">
        <tr>
          <th>Date</th>
          <th>Well Count</th>
          <th>Responsible User</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="variance.length === 0">
          <td colspan="4" class="text-muted">No records.</td>
        </tr>
        <tr *ngFor="let v of variance">
          <td>{{ v.varianceDate | date:'shortDate' }}</td>
          <td>{{ v.wellCount }}</td>
          <td>{{ v.responsibleUserName || v.responsibleUser }}</td>
          <td>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteVariance(v)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Report Recipients ──────────────────────────────────────────────── -->
  <div *ngIf="activeTab === 'billing'">
    <button class="btn btn-sm btn-outline-success mb-2" (click)="showAddBilling = !showAddBilling">
      + Add Recipient
    </button>

    <div *ngIf="showAddBilling" class="card p-3 mb-3" style="max-width:400px;">
      <div class="mb-2">
        <label class="form-label">Email Address</label>
        <input class="form-control" type="email" [(ngModel)]="newBillingEmail" placeholder="user@example.com" />
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-primary" (click)="addBillingOwner()"
                [disabled]="!newBillingEmail">Save</button>
        <button class="btn btn-sm btn-secondary" (click)="showAddBilling = false">Cancel</button>
      </div>
    </div>

    <div *ngIf="billingLoading" class="text-muted">Loading...</div>
    <table *ngIf="!billingLoading" class="table table-sm table-hover">
      <thead class="table-light">
        <tr>
          <th>Email</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="billingOwners.length === 0">
          <td colspan="2" class="text-muted">No recipients.</td>
        </tr>
        <tr *ngFor="let b of billingOwners">
          <td>{{ b.ownerEmail }}</td>
          <td>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteBillingOwner(b)">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Wildcard Rules ─────────────────────────────────────────────────── -->
  <div *ngIf="activeTab === 'wildcards'">
    <p class="text-muted small mb-2">
      Use SQL LIKE syntax: <code>%text%</code> includes wells matching the pattern;
      negate to exclude matches.
    </p>
    <button class="btn btn-sm btn-outline-success mb-2" (click)="showAddWildcard = !showAddWildcard">
      + Add Rule
    </button>

    <div *ngIf="showAddWildcard" class="card p-3 mb-3" style="max-width:480px;">
      <div class="mb-2">
        <label class="form-label">Pattern (SQL LIKE)</label>
        <input class="form-control" [(ngModel)]="newWildcard.wildcardText" placeholder="%sometext%" />
      </div>
      <div class="mb-2 form-check">
        <input class="form-check-input" type="checkbox" id="newNegate" [(ngModel)]="newWildcard.negate" />
        <label class="form-check-label" for="newNegate">Negate (exclude matches)</label>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-primary" (click)="addWildcard()"
                [disabled]="!newWildcard.wildcardText">Save</button>
        <button class="btn btn-sm btn-secondary" (click)="showAddWildcard = false">Cancel</button>
      </div>
    </div>

    <div *ngIf="wildcardLoading" class="text-muted">Loading...</div>
    <table *ngIf="!wildcardLoading" class="table table-sm table-hover">
      <thead class="table-light">
        <tr>
          <th>Pattern</th>
          <th>Type</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="wildcardRules.length === 0">
          <td colspan="3" class="text-muted">No rules.</td>
        </tr>
        <tr *ngFor="let r of wildcardRules">
          <td>
            <span *ngIf="!r.editing">{{ r.wildcardText }}</span>
            <input *ngIf="r.editing" class="form-control form-control-sm" [(ngModel)]="r.wildcardText" />
          </td>
          <td>
            <span *ngIf="!r.editing">
              <span *ngIf="r.negate" class="badge bg-warning text-dark">Exclude</span>
              <span *ngIf="!r.negate" class="badge bg-success">Include</span>
            </span>
            <div *ngIf="r.editing" class="form-check">
              <input class="form-check-input" type="checkbox" [id]="'negate_' + r.id" [(ngModel)]="r.negate" />
              <label class="form-check-label" [for]="'negate_' + r.id">Negate</label>
            </div>
          </td>
          <td>
            <div class="d-flex gap-1">
              <button *ngIf="!r.editing" class="btn btn-sm btn-outline-secondary" (click)="r.editing = true">Edit</button>
              <button *ngIf="r.editing" class="btn btn-sm btn-primary" (click)="saveWildcard(r)">Save</button>
              <button *ngIf="r.editing" class="btn btn-sm btn-secondary" (click)="r.editing = false">Cancel</button>
              <button class="btn btn-sm btn-outline-danger" (click)="deleteWildcard(r)">Delete</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
